<template>
    <div v-if="$showModal('contactUs')" class="custom_popup_wrapper">
        <div class="custom_popup_inner">
            <div
                id="contact_us"
                v-click-outside="onClose"
                class="b_modal white_modal mfp-hide zoom-anim-dialog"
            >
                <div class="modal_content_inner">
                    <div class="single_modal_title second_font text_center">
                        צור קשר
                    </div>

                    <div v-if="!success" class="form_wrapper">
                        <div class="form_row">
                            <div class="label_title">
                                שם פרטי
                            </div>

                            <input
                                v-model="formData.name"
                                type="text"
                                placeholder="מה שמך?"
                                :class="{ 'is-invalid': hasError('name') }"
                                class="form_control"
                            />

                            <div class="invalid-feedback">
                                {{ getError('name') }}
                            </div>
                        </div>

                        <div class="form_row">
                            <div class="label_title">
                                נושא הפנייה
                            </div>

                            <input
                                v-model="formData.topic"
                                type="text"
                                placeholder="באיזה נושא הפנייה?"
                                :class="{ 'is-invalid': hasError('topic') }"
                                class="form_control"
                            />

                            <div class="invalid-feedback">
                                {{ getError('topic') }}
                            </div>
                        </div>

                        <div class="form_row">
                            <div class="label_title">
                                אימייל
                            </div>

                            <input
                                v-model="formData.contact"
                                type="text"
                                placeholder="כיצד ליצור איתך קשר?"
                                :class="{ 'is-invalid': hasError('contact') }"
                                class="form_control"
                            />

                            <div class="invalid-feedback">
                                {{ getError('contact') }}
                            </div>
                        </div>

                        <div class="form_row">
                            <div class="label_title">
                                פנייה
                            </div>

                            <textarea
                                v-model="formData.message"
                                type="text"
                                placeholder="תוכן פנייתך"
                                :class="{ 'is-invalid': hasError('message') }"
                                class="form_control"
                                rows="3"
                            />

                            <div class="invalid-feedback">
                                {{ getError('message') }}
                            </div>
                        </div>

                        <div class="btn_wrapper text_left">
                            <button
                                class="btn btn_green"
                                type="button"
                                @click="contact"
                            >
                                שלח
                            </button>
                        </div>

                        <recaptcha-message />
                    </div>

                    <div v-else class="successfull_message">
                        <div class="message text_center">
                            ההודעה נשלחה בהצלחה!
                        </div>
                    </div>
                </div>

                <button
                    title="Close (Esc)"
                    type="button"
                    class="mfp-close"
                    @click="onClose"
                >
                    ×
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import { StatusCodes as HTTP } from 'http-status-codes';
import { required, email } from 'vuelidate/lib/validators';

import recaptchaMixin from '@/mixins/recaptcha.mixin.js';

export default {
    mixins: [recaptchaMixin],

    props: {
        email: {
            type: String,
            required: true
        }
    },

    validations: {
        formData: {
            name: {
                required
            },
            contact: {
                required,
                email
            },
            topic: {
                required
            },
            message: {
                required
            }
        }
    },

    data() {
        const defaultForm = {
            name: '',
            contact: '',
            topic: '',
            message: ''
        };

        return {
            success: false,
            serverErrors: [],
            formData: { ...defaultForm },
            defaultForm
        };
    },

    methods: {
        ...mapActions({
            sendMessage: 'aboutUs/contactUs'
        }),

        onClose() {
            this.resetForm();
            this.$closeModal();
        },

        resetForm() {
            this.$v.$reset();
            this.success = false;
            this.formData = { ...this.defaultForm };
        },

        async contact() {
            this.serverErrors = [];

            this.$v.$touch();

            if (this.$v.$invalid) {
                return;
            }

            try {
                const recaptchaToken = await this.$recaptcha.execute(
                    'contactUs'
                );

                await this.sendMessage({
                    _token: recaptchaToken,
                    email: this.email,
                    ...this.formData
                });

                this.success = true;
            } catch (error) {
                const { response } = error;

                if (response) {
                    const { data, status } = response;

                    if (status == HTTP.BAD_REQUEST && data.errors) {
                        this.serverErrors = data.errors;

                        this.$toasted.error('אנא בדקו את הערכים בטופס');

                        return;
                    }
                }

                this.$toasted.global.error();

                console.error(error);
            }
        },

        hasError(key) {
            return (
                this.$v.formData[key].$error ||
                this.serverErrors.find(error => error.param === key)
            );
        },

        getError(key) {
            return this.$getValidationErrorMessageHandler.handle(
                this.$v.formData,
                this.serverErrors,
                key
            );
        }
    }
};
</script>
